<template v-slot="extension">
  <div>
    <div v-if="isMaster">
      <v-tabs color="primary" slider-color="blue" dark v-model="model">
        <v-tab v-for="i in dashboardTabs" :key="i" :href="`#tab-${i}`">
          {{ getTabTitle(i) }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="model">
        <v-tab-item v-for="i in dashboardTabs" :key="i" :value="`tab-${i}`">
          <v-card flat>
            <v-card-text>
              <div v-if="i === 1">
                <dashboard-bon-coup />
              </div>
              <div v-else-if="i === 2">
                <dashboard-db-manager-tabs @created="onFormSave()" />
              </div>
              <div v-else-if="i === 3">
                <dashboard-contact-list />
              </div>
              <div v-else-if="i === 4">
                <dashboard-text-result />
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <div v-else>
      <dashboard-page />
    </div>
  </div>
</template>
<script>
import eventBus from '@/helpers/event-bus'
import {mapGetters} from 'vuex'
import DashboardPage from '@/views/Report/DashboardPage'
import DashboardBonCoup from '@/views/Report/DashboardBonCoup'
import DashboardDbManagerTabs from '@/views/Report/DashboardDbManagerTabs'
import DashboardContactList from '@/views/Report/DashboardContactList'
import DashboardTextResult from '@/views/Report/DashboardTextResult'

export default {
  name: 'DashboardTabs',
  mounted() {},
  data() {
    return {
      valid: false,
      selectedScenario: -1,
      showForm: true,
      model: !this.$route.query.dashboardScenarioId ? 'tab-1' : 'tab-2',
      dashboardTabs: 4,
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    isMaster() {
      return this.clientId == 0
    },
  },
  methods: {
    onFormSave() {
      setTimeout(() => {
        eventBus.$emit('refreshDashboards')
      }, 600)
    },
    getTabTitle(i) {
      let title = ''
      switch (i) {
        case 1:
          title = 'Bon Coup'
          break
        case 2:
          title = 'Dashboard'
          break
        case 3:
          title = 'Contact'
          break
        case 4:
          title = 'AMF'
          break
        default:
          title = ' '
          break
      }
      return title
    },
  },
  components: {
    DashboardPage,
    DashboardDbManagerTabs,
    DashboardBonCoup,
    DashboardContactList,
    DashboardTextResult,
  },
}
</script>
